export interface ResendVerifyEmailRequestModel {
  email: string;
}
